import locationNotesTemplate from './locationNotes.html';
import './locationNotes.scss';

export default angular
  .module('main.locations.edit.components.notes', [])

  /**
   * Location notes textarea with autosave feature
   */
  .directive('editLocationNotes', () => {
    return {
      restrict: 'E',
      template: locationNotesTemplate,
      scope: {},
      controller: ($scope,
                   EditLocationDataProvider,
                   ToastsService,
                   utils) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        init();

        function init() {
          $scope.dataProvider.locationResource.init()
            .then(() => {
              $scope.notes = $scope.dataProvider.locationResource.value.notes;
            });

          $scope.notesNgModelOptions = {
            updateOn: 'default blur submit',
            debounce: { 'default': 1000, 'blur': 0, 'submit': 0 }
          };

          $scope.$watch('notes', (newVal, oldVal) => {
            if (newVal != oldVal) {
              saveNotes();
            }
          });
        }

        function saveNotes() {
          if ($scope.dataProvider.locationResource.loading) {
            return;
          }
          if ($scope.dataProvider.locationResource.value.notes == $scope.notes) {
            return;
          }
          $scope.dataProvider.locationResource.value.notes = $scope.notes;
          $scope.savingIndicator = true;
          $scope.dataProvider.saveLocationNotes($scope.notes)
            .then(() => {
              $scope.savingIndicator = false;
              ToastsService.success();
            }, (err) => {
              $scope.savingIndicator = false;
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
